<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:00em;">This book is dedicated to Erik’s wife Marly and his three children: Lize, Rolf and Myré.</p>
<br/><p style="text-indent:00em;">Also, to the children of the world.</p>
<br/><p style="text-indent:00em;">Marly has always supported me in the ideas I had about the world and how we could make that world better. We started with absolutely nothing together, the basis was our love for each other and from this deep feeling we have been able to shape our lives in a beautiful way.</p>
<br/><p style="text-indent:00em;">It is also surprising that love gave rise to three children who are more important to me than my own life. Deep gratitude that they are here and that we can make this journey of life together. Through my three children I was able to develop feelings that gave me insights into my real nature and how we should relate to real nature. Being connected is the concept why we are present on mother Earth.</p>
<br/><p style="text-indent:00em;">Moreover, the children of the world need pure understanding of what is the basis of happiness, how to really relate positively to each other, to understand each other well and to live a life filled with enthusiasm. For this you need to have knowledge about how your brain works and what the influence is of the digital environmental processes. How can we make the journey through life in such a way that we are happy, healthy and that we use in a positive way the resources that the creative human mind develops. The aim is to develop yourself optimally, to have a connection with each other and to be able to deal well with the digital world. This to lead a healthy and successful life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?143b4927